import { useMutation } from '@tanstack/react-query';

import { ApiPairs } from 'api';
import { Response } from 'api/apiBase/Response';
import { ICreateMultiTransferPayload, ICreateMultiTransferResponse } from 'api/apiPairs/models';

export const useCreateMultiTransfer = (pairId: number) =>
  useMutation<Response<ICreateMultiTransferResponse>, unknown, ICreateMultiTransferPayload>({
    mutationKey: ['pairs', pairId, 'multi-transfer', 'create'],
    mutationFn: payload => ApiPairs.createMultiTransferTask({ pairId, payload }),
  });
